import styled from 'styled-components'

import { PAGE_CONTAINER_HORIZONTAL_MOBILE_SPACING } from '@/components/shared/page-container/styled'
import { Flex } from '@/ui/atoms/flex'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const SearchListContainer = styled.ul(
  ({ theme }) => `
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.default};

      & a, & span {
        text-decoration: none;
        cursor: pointer;
      }
      & a:hover h3, 
      & a:focus h3,
      & span:hover h3, 
      & span:focus h3 {
        text-decoration: underline;
      }

    `
)

export const SearchGridContainer = styled.div(
  ({ theme }) => `
    display: grid;
    gap: ${theme.spacing.default};
    grid-template-columns: repeat(auto-fill, minmax(24rem, 1fr));
  `
)

export const TopAdsContainer = styled.div(
  ({ theme }) => `
  background: ${theme.colors.white};
  padding: ${theme.spacing.default};
  margin: 0 -${PAGE_CONTAINER_HORIZONTAL_MOBILE_SPACING};

  ${MEDIA_QUERIES(theme).medium}{
    background: ${theme.colors.purple.light5};
    margin: 0;
  }
`
)

export const PaginationLinkContainer = styled(Flex)(
  ({ theme }) => `
  flex-direction: column;

  ${MEDIA_QUERIES(theme).medium}{
    flex-direction: row;
    justifyContent: space-between;
  }
`
)

export const HighlightedKeyword = styled.strong`
  font-weight: bold;
`

export const FullScreenDivider = styled.div(
  ({ theme }) => `
  margin-left: -${theme.spacing.default};
  width: 100vw;

  ${MEDIA_QUERIES(theme).medium}{
    display: none;
  }
`
)

// LISTING DRAWER

export const DrawerDraggableHeaderContent = styled(Flex)(
  ({ theme }) => `
  gap: ${theme.spacing.defaultSmall};
  margin-bottom: ${theme.spacing.defaultSmall};
  margin-top: ${theme.spacing.large};
`
)

export const PopularKeywordsWrapper = styled.div(
  () => `
  overflow: auto;
  white-space: nowrap;
`
)
